import React from 'react';
import {observer} from 'mobx-react'
import BaseBindedComponent, { BaseBindedComponentProps, BaseBindedComponentState } from '../base-components/BaseBindedComponent'
import ComponentOuterDiv from "./ComponentOuterDiv";
import {getValueList} from "../../utils/valueList-utils";
import {notEmpty} from "../../utils/validation-utils";
import { IDomainData, IUIRadioColDef, IUIRadioDef } from '../../datatypes';
import { DomainAttrInUIComponentProps } from './BaseUIComponent';

const {MDBCol, MDBInput} = require('mdbreact');

interface RadioProps extends BaseBindedComponentProps{
    /** @override */
    metadata:IUIRadioDef|IUIRadioColDef;
    /** @override */
    domainAttribute:DomainAttrInUIComponentProps;    
}


class Radio extends BaseBindedComponent<RadioProps, BaseBindedComponentState> {

  constructor(props: RadioProps & {[key:string]:IDomainData}) {
    super(props)
    this.state = {
      validators: []
    }
  }

  async componentDidMount() {
    super.componentDidMount();
    if(!this.props.metadata.readonly){
      let validators = [];
      if(this.props.metadata.required) validators.push(notEmpty)
      this.setState({validators: validators})
    }
  }

  render() {
    const props = this.props as RadioProps & {[key:string]:IDomainData};  
    const {metadata, domainAttribute, formBean} = this.props;
    const {
      properties,
      label,
      required,
      disabled,
      readonly,
      cssClasses,
      componentId,
    } = metadata;

    let width:string|undefined;
    let valueList:string|undefined;
    switch(metadata.type){
        case 'Radio': valueList = metadata.valueList; break;
        case 'RadioCol': width = metadata.width; break;
    }

    let {xs, sm, md, lg} = properties||{};
    let requiredClass = required ? ' ui-radio-group-required' : ''
    let readonlyClass = readonly ? ' ui-radio-group-readonly' : ''
    let disabledClass = disabled ? ' ui-radio-group-disabled' : ''
    let className = (cssClasses ? cssClasses : '') + disabledClass + readonlyClass + requiredClass
    let parsedlabel = required || readonly || disabled ? label : label + ' (optional)'
    let tabindex = readonly ? -1 : 0;
    let id = domainAttribute.namePrefix + componentId
    id = (id.charAt(0).toLowerCase() + id.slice(1)).replace(/\./g, "-");

    const{dataList, dropDownListKey,dropDownListValue} = getValueList(this.props.formBean, valueList, domainAttribute.objectName, domainAttribute.name, componentId);
    let hasError = !!this.props.error;

    return (
        dataList && dataList.length > 0 ?
            (
              <ComponentOuterDiv width={width} dataGridField={!!this.props.dataGridField} xs={xs} sm={sm} md={md} lg={lg}>
                <div className={'ui-radio-button-group ' + className}>
                  <p>{props.dataGridField ? ' ' : parsedlabel}</p>
                  {dataList.map((ele, idx) => <MDBInput
                          name={id}
                          key={idx}
                          tabIndex={tabindex}
                          label={ele[dropDownListValue]}
                          id={id + '_' + idx}
                          type={"radio"}
                          className={''}
                          disabled={disabled}
                          checked={props[domainAttribute.objectName][domainAttribute.name] === ele[dropDownListKey] ? true : false}
                          required={required}
                          onChange={(v: any) => this.onChangeHandler(ele[dropDownListKey])}
                      />
                  )}
                </div>
                {hasError && <div className={"invalid-feedback"}>{this.props.error}</div>}
              </ComponentOuterDiv>
             ) : null
    )
  }
}

export default observer(Radio);